// Call populateLocations when the page loads to populate the location dropdown immediately
window.onload = function() {
  populateLocations(); // Populate locations on page load
};

// Added on: 15 Apr
const store_location_obj = JSON.parse(document.getElementById('pickup-locations-json').textContent);
// Addon on: 15 Apr

// Function to populate locations dropdown
function populateLocations() {
  // const mlvlocationapiUrl = 'https://www.mlveda.com/ShopifyApps/indianriverdirect-test/location';
  const mlvlocationapiUrl = 'https://www.mlveda.com/ShopifyApps/indianriverdirectAPI/location';
  
  fetch(mlvlocationapiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const locationSelect = document.getElementById("MLVlocation");
      
      // Clear any existing options (optional, in case this function is called more than once)
      locationSelect.innerHTML = '<option class="hideoption">Select a location</option>';

      // Sort locations alphabetically before populating the dropdown
      data.sort((a, b) => a.locationName.localeCompare(b.locationName));
      
      // Populate location options from API data
      data.forEach(location => {
        const option = document.createElement("option");
        // Original Code:
        // option.value = location.locationName;
        // Updated Code: Start 15 Apr
        if(store_location_obj[location.locationId]){
          option.value = store_location_obj[location.locationId].replace(/&#39;/g, "'");

          option.setAttribute("data-id", location.locationId);
        }else{
          option.value = location.locationName;
        }
        // Updated Code: END
        option.text = location.locationName;
        locationSelect.add(option);
      });

      // Listen for a change event on the location dropdown
      locationSelect.addEventListener('change', function() {
        const selectedLocation = locationSelect.value;
        
         // Updated Code: Start 15 Apr
         locationSelect.setAttribute("data-id",locationSelect.querySelector(`option[value="${selectedLocation}"`).getAttribute("data-id"))
         // Updated Code: END
        
        if (selectedLocation !== "") {
          // Disable the "Select a location" option when a location is selected
          locationSelect.querySelector('.hideoption').disabled = true;
        }
        
        console.log("Selected Location:", selectedLocation); // Log selected location
        
        //  mlgetdateandtime(); // Trigger the date fetch after location selection
        
        // Updated Code: Start 15 Apr
        if (locationSelect.value) {
          mlgetdateandtime(); // Call this if location is pre-selected
        }
        // Updated Code: END
      });
      
      // Automatically trigger location change if there’s already a selection (optional)
      if (locationSelect.value) {
        mlgetdateandtime(); // Call this if location is pre-selected
      }
    })
    .catch(error => {
      console.error('Error fetching locations:', error);
    });
}

// Function to fetch and display available dates and times based on location
function mlgetdateandtime() {
  // Original Code: Start 15 Apr
  // const selectedLocation = document.getElementById("MLVlocation").value.toLowerCase();
  // Original Code: End

  // Updated Code: Start 15 Apr
    const selectedLocation = document.getElementById("MLVlocation").getAttribute("data-id");
  // Updated Code: End
  
  // const mlvlocationapiUrl = 'https://www.mlveda.com/ShopifyApps/indianriverdirect-test/location';
  const mlvlocationapiUrl = 'https://www.mlveda.com/ShopifyApps/indianriverdirectAPI/location';

  // Reset date and time fields
  const dateSelect = document.getElementById("date");
  dateSelect.innerHTML = '<option class="hideoption">Select a date</option>';
  document.getElementById("deliveryTime").value = "";

  fetch(mlvlocationapiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Original Code: Start 15 Apr
        // const locationData = data.find(location => location.locationName.toLowerCase() === selectedLocation);
      // Original Code: End
     // Updated Code: Start 15 Apr
        const locationData = data.find(location => location.locationId == selectedLocation);
     // Updated Code: End
      if (locationData) {
        // Populate date options for the selected location
        locationData.date.forEach(dateItem => {
          // Format the date to MM/DD/YYYY
          const formattedDate = new Intl.DateTimeFormat('en-US', {'timeZone':'America/New_York'}).format(new Date(dateItem.date));

          // Create a unique value using date + time
          const uniqueDateValue = `${formattedDate} ${dateItem.time}`;

          const option = document.createElement("option");
          option.value = uniqueDateValue; // Store unique value
          option.text = formattedDate; // Display only the date
          option.setAttribute("mlaccociatedtime", dateItem.time); // Store time in the option
          dateSelect.add(option);
        });

        // Remove any existing 'change' event listeners to avoid duplicate triggers
        dateSelect.removeEventListener('change', handleDateChange);
        
        // Attach a single 'change' event listener
        dateSelect.addEventListener('change', handleDateChange);
      }
    })
    .catch(error => {
      console.error('Error fetching dates:', error);
    });
}

// Function to handle date change and display selected date and time
function handleDateChange() {
  const dateSelect = document.getElementById("date");
  const selectedOption = dateSelect.options[dateSelect.selectedIndex];
  
  if (selectedOption.value !== "") {
    dateSelect.querySelector('.hideoption').disabled = true;
  }

  console.log("Selected Date:", selectedOption.text); // Log selected date

  // Update delivery time based on selected date-time pair
  const associatedTime = selectedOption.getAttribute('mlaccociatedtime');
  document.getElementById("deliveryTime").value = associatedTime;
  
  console.log("Associated Time:", associatedTime); // Log associated time
}